const Slope = ({ ...props }) => (
  <svg
    width='88'
    height='88'
    viewBox='0 0 88 88'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ background: '#6C67F1' }}
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M50.6667 24.3696L34.8872 40.1864L24.0001 37.7402L37.3334 24.3696L48.4438 13.3798C49.268 12.5646 50.6667 13.1484 50.6667 14.3077V24.3696ZM37.3339 51.0358L50.6672 37.74V24.3694L35.2001 39.8737L37.3339 51.0358Z'
      fill='url(#paint0_linear_2593_6077)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M37.3337 64.2947V50.9617L50.667 37.6284L55.7849 45.8435L55.9822 45.6463L64 50.9616L39.5582 75.2343C38.7347 76.0521 37.3336 75.4687 37.3336 74.3082V64.2949L37.3337 64.2947Z'
      fill='url(#paint1_linear_2593_6077)'
    />
    <path
      d='M24 37.7405H32.573C35.202 37.7405 37.3333 39.8718 37.3333 42.5009V51.0359H28.7602C26.1313 51.0359 24 48.9046 24 46.2757V37.7405Z'
      fill='#F1F0FF'
    />
    <path
      d='M50.6667 37.7405H59.2398C61.8688 37.7405 64 39.8718 64 42.5009V51.0359H55.4271C52.798 51.0359 50.6667 48.9046 50.6667 46.2757V37.7405Z'
      fill='#F1F0FF'
    />
    <defs>
      <linearGradient
        id='paint0_linear_2593_6077'
        x1='37.3336'
        y1='13'
        x2='37.3336'
        y2='51.0358'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#A8ADFF' />
        <stop offset='0.648556' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_2593_6077'
        x1='50.6668'
        y1='37.6284'
        x2='50.6668'
        y2='75.616'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0.260784' stopColor='#B6BAFF' />
        <stop offset='1' stopColor='#E4E2FF' />
      </linearGradient>
    </defs>
  </svg>
);

export default Slope;
